<div *ngIf="control.Visible || showConditionalObjects || showConditionals" style="padding: 0px 5px;"
  [ngStyle]="{'min-width': !config.IsMobilePreview && control.ControlType != 'component' && (control.ControlType == 'textbox' || control.ControlType == 'note' || control.ControlType == 'divider' || control.ControlType == 'dropdown' || control.ControlType == 'date') ? control.Width : ''
    , 'padding-left': control.Indent ? (control.Indent + 'px') : '0px'
    , 'background-color': highlightChanges ? 'rgb(255, 229, 151)' : ''
    , 'width': config.IsMobilePreview ? '100%' : ''}">
  <div *ngIf="!control.CustomField">
    <!-- Text -->
    <div class="eFormControl" *ngIf="control.ControlType == 'text'" style='display:flex;'
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}" #eFormControl>
      <div *ngIf="control.TextProvidedOnInstance && viewType == 'template'">
        <span *ngIf="control.Instructions">[{{control.Instructions}}]</span>
        <span *ngIf="!control.Instructions">[No instructions entered]</span>
      </div>
      <quill-editor *ngIf="!control.TextProvidedOnInstance || viewType != 'template'"
        [ngModel]="control.Value | tylTranslate | translate | mergeField: mergeFieldValuesRetrieved: pipeTrigger"
        [readOnly]="true" placeholder="No text entered" class="ql-textOnly" [name]="'quill' + control.Id">
      </quill-editor>
    </div>

    <!-- Divider -->
    <div class="eFormControl" *ngIf="control.ControlType=='divider'" #eFormControl>
      <!-- control.RemoveBottomPadding may be null, in which case the padding should NOT show. -->
      <mat-divider style="flex:1;" [ngStyle]="{'padding-bottom': control.RemoveBottomPadding == false ? '1.34375em' : '0px'}"></mat-divider>
    </div>

    <!--Vertical Divider --> 
    <div *ngIf="control.ControlType=='verticalDivider'" class="eFormControl verticalDividerContainer" [ngStyle]="{'padding-top': control.PaddingTop}">
      <mat-divider vertical class="verticalDivider" [ngStyle]="{'height': control.Height}"></mat-divider>
    </div>

    <!-- Image -->
    <div class="eFormControl" *ngIf="control.ControlType=='image'"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}" #eFormControl>
      <img [alt]="control.Label ? control.Label : 'Image'"
        [src]="!control.Attachment ? '' : 'data:' + control.Attachment.FileType + ';base64,' + control.Attachment.FileDataBase64 | safeResourceUrl">
    </div>

    <!-- Buttons -->
    <div class="eFormControl" *ngIf="control.ControlType == 'buttons'" style="flex-direction: column;"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}" #eFormControl>
      <label
        [ngStyle]="{'color': control.HasError ? '#b71c1c' : ''}">{{control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)}}<span
          *ngIf="control.IsRequired" style="color:red;">&nbsp;*</span></label>
      <mat-chip-list [id]="'chipList' + control.Label">
        <mat-chip [id]="'chip' + chip.Code" *ngFor='let chip of control.DropdownOptions'
          [selected]='control.Value == chip.Code' (click)="control.Value = chip.Code" (selectionChange)="valueChanged()"
          [disabled]='!editable'>
          {{chip.CodeDescription | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger}}</mat-chip>
      </mat-chip-list>
    </div>

    <!-- Checkbox -->
    <div class="eFormControl" *ngIf="control.ControlType == 'checkbox'"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}" #eFormControl>
      <tyl-checkbox [(checked)]='control.Value' (change)='valueChanged()' [disabled]='!editable'>
        <span
          [ngStyle]="{'color': control.HasError ? '#b71c1c' : ''}">{{control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)}}</span>
        <span *ngIf="control.IsRequired" style="color: red; font-weight: bold;">&nbsp;*</span>
      </tyl-checkbox>
    </div>

    <!-- Checkbox with Textbox -->
    <div class="eFormControl" *ngIf="control.ControlType == 'checkboxWithTextbox'"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}" #eFormControl>
      <tyl-checkbox [(checked)]='control.Value' (change)='valueChanged()' [disabled]='!editable'>
        <span>{{control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)}}</span></tyl-checkbox>
      <tyl-form-field>
        <input matInput id='inpChkTxt' type='text' [disabled]='!editable' />
      </tyl-form-field>
    </div>

    <!-- Dropdown -->
    <div class="eFormControl" *ngIf="control.ControlType == 'dropdown'" #eFormControl>
      <tyl-form-field [postLabelSpace]='true' [label]='control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)'
        [required]="control.IsRequired" [ngStyle]="{'width': config.IsMobilePreview ? '100%' : (control.Width ? control.Width : '')}">
        <mat-select [id]="'ddl' + control.Label" [required]="control.IsRequired" [(ngModel)]='control.Value'
          (selectionChange)="valueChanged()" [disabled]='!editable' [name]="'ddl' + control.Id">
          <mat-option *ngIf="!control.IsRequired" value=""></mat-option>
          <mat-option *ngFor='let option of control.DropdownOptions' [value]='option.Code'>
            {{option.CodeDescription | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger}}
          </mat-option>
        </mat-select>
      </tyl-form-field>
    </div>

    <!-- Note -->
    <div class="eFormControl" *ngIf="control.ControlType == 'note'" #eFormControl>
      <tyl-form-field *ngIf="!print" [postLabelSpace]='true'
        [label]='control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)'
        [required]="control.IsRequired" [ngStyle]="{'width': config.IsMobilePreview ? '100%' : (control.Width ? control.Width : '')}">
        <textarea matInput [id]="'txt' + control.Label" [required]="control.IsRequired" [rows]="control.NoteRows"
          [(ngModel)]='control.Value' [name]="'ta' + control.Id" (change)="valueChanged()"
          [disabled]='!editable'></textarea>
      </tyl-form-field>
      <div *ngIf="print" [ngStyle]="{'width': config.IsMobilePreview ? '100%' : (control.Width ? control.Width : '')}">

        <div style="font-size: smaller;
                  position: relative;
                  top: 8px;
                  left: 8px;">
          {{control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)}}
        </div>
        <div id="noteField" style=" background: rgba(0, 0, 0, .06) !important;
                    padding: 7.5px;
                    border: 1px solid;
                    border-radius: 5px;
                    border-top: 0px;
                    opacity: 1 !important;
                    border-color: rgba(0,0,0,.12);">
          {{control.Value}}
        </div>
      </div>
    </div>

    <!-- Textbox -->
    <div class="eFormControl" *ngIf="control.ControlType == 'textbox'" #eFormControl>
      <tyl-form-field [postLabelSpace]='true' [label]='control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)'
        [required]="control.IsRequired" [ngStyle]="{'width': config.IsMobilePreview ? '100%' : (control.Width ? control.Width : '')}">
        <input matInput [id]="'inp' + control.Label" [type]="control.DataType == 'number' ? 'number' : 'text'"
          [required]="control.IsRequired" [(ngModel)]='control.Value' (change)="valueChanged()" [disabled]='!editable'
          [name]="'tb' + control.Id" />
      </tyl-form-field>
    </div>

    <!-- Radio Buttons -->
    <div class="eFormControl" *ngIf="control.ControlType == 'radioButtons'"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}" #eFormControl>
      <div>
        <table>
          <tr >
            <td style="padding-bottom: 10px;">
              {{control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)}}
              <span class="redStar" *ngIf="control.IsRequired" style="color: red;">*</span><br> 
            </td>
          </tr>
          <tr *ngFor='let opt of control.DropdownOptions' style="padding-left: 12px;">
            <td>
              <mat-radio-button id="{{'rb'+ '_' + control.Id + '_' + (opt.Code.trim()).replace(' ', '_')+ '_' + control.Label}}"
                name="{{'rbName'+ '_' + control.Id + '_' + (opt.Code.trim()).replace(' ', '_')+ '_' + control.Label}}"
                [checked]="control.Value == opt.Code.trim()" [value]="opt.Code.trim()" [disabled]='!editable'
                (click)="editable && SetRadioValue(control.Value,opt.Code.trim())">
                {{opt.CodeDescription | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger}}
              </mat-radio-button>
            </td>
          </tr>
        </table>
        <br>
      </div>
    </div>

    <!-- Date -->
    <div class="eFormControl" *ngIf="control.ControlType == 'date'" #eFormControl>
      <tyl-datepicker [id]="'date' + control.Label"
      [postLabelSpace]='true' [label]="control.HideLabel ? '' : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)"
        [(value)]="dateValue" [truncateLabel]="control.IsRequired" [isRequired]="control.IsRequired"
        [ngStyle]="{'width': config.IsMobilePreview ? '100%' : (control.Width ? control.Width : '')}" (valueChange)="valueChanged()"
        [disabled]='!editable'></tyl-datepicker>
    </div>

    <!-- Attachment -->
    <div class="eFormControl" *ngIf="control.ControlType == 'attachment' && control.Attachment"
      style="flex-direction: column;" [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}"
      #eFormControl>
      <span [ngStyle]="{'color': control.HasError ? '#b71c1c' : ''}">
        {{control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)}}
        <span *ngIf="control.IsRequired" style="color: red; font-weight: bold;">&nbsp;*</span>
      </span>
      <add-file [(fileString)]="control.Attachment.FileDataBase64" [(fileName)]="control.Attachment.OriginalFileName"
        [(fileExtension)]="control.Attachment.FileExtension" [(fileType)]="control.Attachment.FileType"
        [required]="control.IsRequired" [hideRequiredAsterisk]="true" [disabled]='!editable'
        (changes)="attachmentChanged()" *ngIf="control.Attachment.ID == 0 || control.Attachment.ID == null || editable"
        [maxFileSize]="maxFileSizeByte" [maxFileSizeMessage]="maxFileSizeMessage" accepts=".bmp, .jpg, .png, .pdf">
      </add-file>
      <div *ngIf="control.Attachment.ID > 0  && !editable" style="display: flex; flex-direction: column;">
        <a *ngIf="!print" style="cursor: pointer; padding-top: 10px; padding-bottom: 10px;"
          (click)="saveAttachment(control.Attachment)">
          {{control.Attachment.OriginalFileName}}
        </a>

        <div *ngIf="print"><span style="font-weight: bold;">ATTACHMENT
            -&nbsp;&nbsp;</span>{{control.Attachment.OriginalFileName}}</div>
      </div>
    </div>

    <!-- Link To File -->
    <div class="eFormControl" *ngIf="control.ControlType == 'linkToFile'"
      [ngStyle]="{'padding-bottom': control.RemoveBottomPadding ? '0px' : '1.34375em'}" #eFormControl>
      <a class="link"
        (click)="linkClick()">{{control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger}}</a>
    </div>
  </div>

  <div *ngIf="control.CustomField || control.ControlType == 'component'">
    <!-- Custom Field -->
    <div style='display:flex;' class="designerControl" style="flex-direction: column;" *ngIf="control.ControlType != 'component'"  #eFormControl>
      <!-- <label>{{control.HideLabel ? "" : (control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger)}}<span *ngIf="control.IsRequired && !control.HideLabel" style="color:red;">*</span></label> -->
      <div *ngIf="control.CustomFieldName">
        <custom-data-field [fieldName]="control.CustomFieldName" [masterId]="masterId" [(value)]="control.Value" #customField [pageIndex]="designPageIndex"
            (valueChange)="valueChanged();" [allowControlToHandleOwnData]="control.CustomFieldAllowControlToHandleOwnData ? control.CustomFieldAllowControlToHandleOwnData : false"
            [width]="control.Width" [label]="control.Label | tylTranslate | translate | mergeField: disableMergeFields: pipeTrigger" [hideLabel]="control.HideLabel"
            [required]="control.IsRequired" [hintLabel]="control.HintLabel" [noteRows]="control.NoteRows" [persistDataInMemory]="config.PersistCustomFieldDataInMemory"
            [readOnly]="!control.Editable" [controlTypeID]="control.CustomFieldControlTypeID" >
          </custom-data-field>
      </div>
    </div>
    <!-- Custom Component -->
    <div class="designerControl" style="flex-direction: column;display:flex;" *ngIf="control.ControlType == 'component'">
      <ng-container *ngTemplateOutlet="contentTemplate; context: {designPageIndex: designPageIndex, masterId: masterId}"></ng-container>
    </div>
  </div>
</div>
